module.exports = __webpack_public_path__ + "img/H32-uruguay.012c08a1.png";